import React, { ReactElement } from "react";
import CampaignDetails from "../../components/Campaign/Details";
import Layout from "../../components/layout";

const CampaignDetailsPage = (): ReactElement => {
  return (
    <Layout>
      <CampaignDetails />
    </Layout>
  );
};

export default CampaignDetailsPage;
